import { render, staticRenderFns } from "./AdvertItem.vue?vue&type=template&id=5ad0a565&scoped=true&"
import script from "./AdvertItem.vue?vue&type=script&lang=js&"
export * from "./AdvertItem.vue?vue&type=script&lang=js&"
import style0 from "./AdvertItem.vue?vue&type=style&index=0&id=5ad0a565&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad0a565",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardActions,VCardTitle,VImg})
